// src/stone/icons/Question.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Question = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12" }),
      /* @__PURE__ */ jsx("path", { d: "M12 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }),
      /* @__PURE__ */ jsx("path", { d: "M13 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12.882 7.019c-.816-.077-1.78.082-2.625.456l-.914.404-.809-1.83.915-.404c1.135-.501 2.442-.728 3.62-.617 1.155.108 2.382.567 3.052 1.651 1.254 2.03.241 4.204-1.433 5.623C13.169 13.588 13 14.007 13 14.5v1h-2v-1c0-1.507.913-2.468 2.395-3.724 1.325-1.123 1.52-2.242 1.024-3.045-.205-.332-.696-.633-1.537-.712" })
    ]
  }
);
var Question_default = Question;

export {
  Question,
  Question_default
};
